import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import MRegion from 'region-selector'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MainArea from "./store/mainArea";
import Moment from 'moment'
import domMessage from './messageOnce'
import axios from 'axios'
import qs from 'qs'
import ShowNavHead from "./components/showNavHead.vue";
import "./routerhook"
import 'vant/lib/index.css';

import {
  Button,
  Area,
  Popup,
  List,
  Picker,
  Checkbox,
  Rate,
  Dialog,
  Toast,
  Cascader,
  Field,
  RadioGroup,
  Form,
  DatetimePicker,
  Radio
}
from 'vant';
Vue.use(Area);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(List);
Vue.use(Checkbox);
Vue.use(Rate);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Cascader);
Vue.use(Field);
Vue.use(Radio);
Vue.use(Form);
Vue.use(DatetimePicker);
Vue.use(RadioGroup);
import {
  VueJsonp
} from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.component("ShowNavHead", ShowNavHead)
import {
  math
} from '@/utils/math.js'


// import {preventReClick } from './directive.js'
// Vue.use(preventReClick )

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.moment = Moment
//提示一次的实例
const messageOnce = new domMessage()
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.directive("focus", {
  bind: function (el) { // 1.每当指令绑定到元素上的时候，会立即执行这个bind函数，【执行一次】
    el.focus()
  },
  inserted: function (el) { // 2.当元素插入到DOM中的时候，会执行 inserted 函数， 【触发一次】
    if (el.tagName.toLocaleLowerCase() == 'input') {
      el.focus()
    } else {
      if (el.getElementsByTagName('input')) {
        el.getElementsByTagName('input')[0].focus()
      }
    }
  },
  updated: function () { // 3.当VNode更新的时候，会执行 updated,【可能触发多次】
    el.focus()
  }
});
const APIHeader = location.origin

const Api = {
  APILogin: APIHeader + "/Login",
  APIEnt: APIHeader + "/Entinfo",
  APIPsn: APIHeader + "/Psninfo",
  APIEntBin: APIHeader + "/EntBin",
  APIAsset: "https://aizhiyeasset.oss-cn-hangzhou.aliyuncs.com",
  APIA: APIHeader + "/ARole",
  // APIB: APIHeader + "/BRole",
}



Vue.prototype.Api = Api

Vue.use(ElementUI);
Vue.use(MRegion);

Vue.config.productionTip = false;
//日期格式化
Vue.filter('formatDate', function (value, caret) {
  let d = new Date(value);
  if (!caret) caret = "-";
  return d.getFullYear() + caret + (d.getMonth() + 1) + caret + d.getDate();
});

Vue.filter('totalSalary', function (data, caret = "-") {
  let minTotal = (data.minsalary * 12 / 10).toFixed(1);
  let maxTotal = (data.maxsalary * 12 / 10).toFixed(1);
  return minTotal + caret + maxTotal + "万";
});
//请求超时时间
axios.defaults.timeout = 120 * 10000;
//请求拦截
axios.interceptors.request.use(config => {
  // console.log('config',config)
  return config
}, err => {
  // console.log('err',err)
  Vue.prototype.$message.error('请求超时')
  Promise.reject(err)
})
// 响应拦截
axios.interceptors.response.use(response => {
  // 这个是处理响应成功的结果，也就是说响应状态码为2XX系列的
  // console.log('response',response)
  let data = response.data;
  // console.log('s',data.status)
  if (data.status == 'quit') {
    Vue.prototype.$message.error('您已离职，不能登录');
    Cookies.remove("userid-b");
    Cookies.remove("entid-b");
    Cookies.remove("token");
    localStorage.clear();
    location.href = "/";
  }
  if (Number(response.status) == 200) {
    return response;
  } else if (Number(response.status) == 401) {
    Cookies.remove("userid-b");
    Cookies.remove("entid-b");
    Cookies.remove("token");
    localStorage.removeItem('activeRoutes');
    localStorage.removeItem('router');
    localStorage.removeItem('activeRouter');
    localStorage.removeItem('isPartner');
    store.commit("setLogin", false);
    location.href = '#/login';
  } else {
    return response;
  }
}, err => {
  // console.log('error22',error)
  if (err.response.status) {
    const status = err.response.status;
    if (status == 401) {
      messageOnce.error({
        message: '登录已过期，请重新登录！',
        type: 'warning'
      })
      Cookies.remove("userid-b");
      Cookies.remove("entid-b");
      Cookies.remove("token");
      localStorage.removeItem('activeRoutes');
      localStorage.removeItem('router');
      localStorage.removeItem('activeRouter');
      localStorage.removeItem('isPartner');
      store.commit("setLogin", false);
      location.href = '#/login';
    } else {
      return Promise.resolve(err)
    }
  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.query.name) {
    document.title = to.query.name
  }
  next()
})

// console.log('router',router)
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000);
      }
    });
  },
});
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');